<!-- spinner component -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" class="nv-spinner" type="ball-spin" [fullScreen]="true"></ngx-spinner>
<app-nav-bar *ngIf="fireAuth.user | async" [menu]="menu"></app-nav-bar>
<div class="ns-body" [class.ns-body-full]="!(fireAuth.user | async)">
    <router-outlet></router-outlet>
</div>
